import { useCallback, useMemo } from "react";
import { useTranslation } from "../hooks";
import { convertNameToId } from "../utils";
export default function useTranslatedDefinitionSize() {
    const { t } = useTranslation();
    const translatedByDefinitionSizeId = useMemo(() => ({
        minimal: t("chatbotFilters:filterByDefinitionSize.sizes.minimal"),
        low: t("chatbotFilters:filterByDefinitionSize.sizes.low"),
        mid: t("chatbotFilters:filterByDefinitionSize.sizes.mid"),
        high: t("chatbotFilters:filterByDefinitionSize.sizes.high"),
        very: t("chatbotFilters:filterByDefinitionSize.sizes.very"),
    }), [t]);
    const getTranslatedDefinitionSize = useCallback((name) => {
        if (!name)
            return "";
        const id = convertNameToId(name);
        return (translatedByDefinitionSizeId[id] ?? name);
    }, [translatedByDefinitionSizeId]);
    return { getTranslatedDefinitionSize };
}
